var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _vm.getDisabled("add")
              ? _c("i", [
                  _vm._v(
                    _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")) +
                      " " +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.ADD"))
                  )
                ])
              : _c("i", [
                  _vm._v(
                    _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")) +
                      " " +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.EDIT"))
                  )
                ])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table mt10" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.LEVEL")))]),
                  _vm._v(" "),
                  _vm.getDisabled("add")
                    ? _c("td", { attrs: { "data-input-type": "select" } }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.levelCd,
                                expression: "levelCd"
                              }
                            ],
                            staticClass: "slt_white w100",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.levelCd = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("1")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("2")
                            ])
                          ]
                        )
                      ])
                    : _c("td", { attrs: { "data-input-type": "select" } }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.levelCd) +
                            "\n                                "
                        )
                      ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")) + "1")
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "select" } }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inquiry1Code,
                            expression: "inquiry1Code"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: {
                          disabled:
                            _vm.getDisabled("inquiry1Code") ||
                            !_vm.getDisabled("add")
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.inquiry1Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.inquiry1CodeList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(item.CD_NAME) +
                                  "\n                                        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.FAQ.INQUIRY")))]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "input" } }, [
                    _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          { name: "clearable", rawName: "v-clearable" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inquiry1Name,
                            expression: "inquiry1Name"
                          }
                        ],
                        staticClass: "text_input w100",
                        attrs: { type: "text" },
                        domProps: { value: _vm.inquiry1Name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.inquiry1Name = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USEDMODULE")))]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "select" } }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.useModule,
                            expression: "useModule"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { disabled: _vm.getDisabled("useModule") },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.useModule = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.useModuleList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(item.CD_NAME) +
                                  "\n                                        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.KPIINCHARGE")))
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "select" } }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.kpiCharge,
                            expression: "kpiCharge"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { disabled: _vm.getDisabled("kpiCharge") },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.kpiCharge = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.kpiChargeList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(item.CD_NAME) +
                                  "\n                                        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.STATUS")))]),
                  _vm._v(" "),
                  _c("td", { attrs: { "data-input-type": "select" } }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.statusCd,
                            expression: "statusCd"
                          }
                        ],
                        staticClass: "slt_white w100",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.statusCd = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.statusCdList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(item.CD_NAME) +
                                  "\n                                        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")) +
                        "\n                            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.getDisabled("add")
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.ADD")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.EDIT")) +
                            "\n                            "
                        )
                      ]
                    )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e088ea4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e088ea4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/qnaManager/popup/inquiryAddPop.vue
// module id = mXtz
// module chunks = 0